import {InjectionToken} from "@angular/core";

export interface IAppAppleMapsConfig {
  readonly placeIds: readonly string[];
  readonly center: {
    readonly latitude: string,
    readonly longitude: string,
  };
  readonly cameraDistance: string;
}

export interface IWebAppAppleMapsConfig {
  readonly token: string;
  readonly map: Readonly<IAppAppleMapsConfig>;
}

export interface IWebAppConfig {
  readonly version: string;
  readonly apiUrl: string;
  readonly apiToken: string;
  readonly appleMapsEmbeddingSettings?: Readonly<IWebAppAppleMapsConfig>;
  readonly cap?: {
    readonly baseUrl: string;
    readonly endpointUrl: string;
    readonly wasmUrl: string;
  };
  readonly trackingDomain?: string;
}

export const WEB_APP_CONFIG = new InjectionToken<Readonly<IWebAppConfig>>("WEB_APP_CONFIG");


export interface IServerAppAppleMapsConfig {
  readonly tokenMap: Readonly<Record<string, string | undefined | null>>;
  readonly map: Readonly<IAppAppleMapsConfig>;

  readonly resolveFor: (host: string | null | undefined) => Readonly<IWebAppAppleMapsConfig> | null;
}

export interface IServerAppConfig {
  readonly internalApiUrl?: string;
  readonly appleMapsEmbeddingSettings?: Readonly<IServerAppAppleMapsConfig>;
}

export const SERVER_APP_CONFIG = new InjectionToken<Readonly<IServerAppConfig>>("SERVER_APP_CONFIG");
